import { Box, Card, alpha, Typography, styled } from "@mui/material";
import LinearProgressTodo from "./LinearProgressTodo";
import { useTranslation } from "react-i18next";
import { useContext, useMemo } from "react";
import { ProfileContext } from "../../contexts/ProfileContext";

const CardProgress = styled(Card)(({ theme }: any) => ({
  backgroundColor: alpha(theme.palette.primary.main, 0.1),
  boxShadow: "none",
  paddingBottom: 5,
}));

const ProfileConstructionCard: React.FC<{
  home?: any;
  progress?: any;
  setProgress?: any;
  sx?: any;
  seeTasks?: any;
}> = ({ home, sx, seeTasks }) => {
  const { t } = useTranslation("common");
  const { tasksProgress, tasks } = useContext(ProfileContext);

  const counter = useMemo(() => countStatuses(tasks), [tasks]);

  const progress = { ...tasksProgress, current: tasksProgress.finished };

  return (
    <CardProgress sx={{ padding: 3, borderRadius: 2, mb: 4, ...sx }}>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box
          display="flex"
          alignItems="flex-start"
          sx={{ mb: 1, justifyContent: "space-between" }}
        >
          <Typography
            variant="body1"
            sx={{ mb: 1, cursor: "pointer" }}
            onClick={seeTasks}
          >
            {t("todo.see_todo_list")}
          </Typography>
        </Box>
        {/* <Typography variant="h5" sx={{ mb: 1 }}>
          {t("todo.profile_construction")}
        </Typography> */}
        <LinearProgressTodo progress={progress} width="90%" />
        {counter.today > 0 && (
          <Typography
            sx={{ color: (theme: any) => theme.palette.warning[600] }}
          >
            {counter.today} pour aujourd'hui
          </Typography>
        )}
        {counter.passed > 0 && (
          <Typography sx={{ color: (theme: any) => theme.palette.error[600] }}>
            {counter.passed} en retard
          </Typography>
        )}
      </Box>
    </CardProgress>
  );
};
export default ProfileConstructionCard;

type Task = {
  id: string;
  title: string;
  status?: string;
  finished: boolean;
  // other fields...
};

type TaskGroup = {
  tasks: Task[];
};

const countStatuses = (groups: TaskGroup[]) => {
  const flatTasks = groups.flatMap((group) => group.tasks || []);

  const counter = { today: 0, passed: 0 };

  flatTasks.forEach((task) => {
    if (task.finished) return;
    if (task.status === "passed") {
      counter.passed++;
    } else if (task.status === "today") {
      counter.today++;
    }
  });

  return counter;
};
